import Dispatche from './dispatche';
import Store from './store';
import Invoice from './invoice';

export default {
  Dispatche,
  Store,
  Invoice,
};
